import { createFileRoute, redirect } from "@tanstack/react-router"

/** Merged into Profile & settings (T1402); kept so bookmarks and old links still land on the form. */
export const Route = createFileRoute("/_app-shell/business")({
  beforeLoad: () => {
    throw redirect({ to: "/account", hash: "business", replace: true })
  },
})
